// extracted by mini-css-extract-plugin
export default {"main":"gridItem_main__WhO2-","gridIcon":"gridItem_gridIcon__TqAQ5","gridTitle":"gridItem_gridTitle__EaS7W","gridInfo":"gridItem_gridInfo__uTBg-","yourImc":"gridItem_yourImc__4AsAw"};